import React from "react";

export function MainLogo() {
  return (
    <svg
      width="150"
      height="60"
      viewBox="0 0 150 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_33_151)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.7979 29.1291L40.1813 48.5126L57.5658 31.1281L28.7907 2.35297L22.7037 8.43991L45.3918 31.1281L39.8728 36.6473L26.5762 23.3506L20.7979 29.1291Z"
          fill="#3B7AFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.015625 31.1281L17.2419 13.9019L23.3289 19.9888L12.1896 31.1281L34.8778 53.8163L28.7908 59.9032L0.015625 31.1281Z"
          fill="#3B7AFE"
        />
        <path
          d="M73.55 27.4598C75.8883 25.0932 78.7253 23.9099 82.0614 23.9099C85.4261 23.9099 88.2777 25.0932 90.6158 27.4598C92.9539 29.8266 94.123 32.678 94.123 36.0141C94.123 36.7271 94.066 37.5967 93.9519 38.6232H77.4422C77.7843 39.5641 78.4188 40.3268 79.3454 40.9115C80.2723 41.496 81.377 41.7883 82.6602 41.7883C84.7134 41.7883 86.3101 41.218 87.4507 40.0773L92.9682 43.5846C91.8561 44.9818 90.352 46.101 88.4557 46.9421C86.5596 47.7834 84.6278 48.204 82.6602 48.204C78.9819 48.204 75.9522 47.0276 73.5713 44.6754C71.1905 42.3229 70 39.4358 70 36.0141C70 32.678 71.1833 29.8266 73.55 27.4598ZM142.663 47.5364V24.3432H149.592V47.5364H142.663ZM118.906 15.354H138.494V22.454H126.263V28.6314H138.118V35.7314H126.263V47.5364H118.906V15.354ZM96.1516 30.5159V24.5359H113.877V29.596L104.906 41.2216H114.462V47.5364H95.912V42.8109L105.031 30.5159H96.1516ZM77.4849 33.4625H86.9374C86.7093 32.513 86.1603 31.7075 85.2907 31.0462C84.4211 30.385 83.3588 30.0543 82.1043 30.0543C80.8781 30.0543 79.8587 30.385 79.0461 31.0462C78.2335 31.7075 77.7131 32.513 77.4849 33.4625Z"
          fill="#3B7AFE"
        />
        <path
          d="M143.226 15.3511C142.419 16.1735 142.016 17.1481 142.016 18.2749C142.016 19.402 142.419 20.3691 143.226 21.1762C144.034 21.9833 145.001 22.3869 146.127 22.3869C147.254 22.3869 148.229 21.9758 149.052 21.1533C149.843 20.3615 150.239 19.402 150.239 18.2749C150.239 17.1481 149.836 16.1735 149.029 15.3511C148.221 14.5288 147.254 14.1177 146.128 14.1177C145.001 14.1177 144.034 14.5288 143.226 15.3511Z"
          fill="#5FBF24"
        />
      </g>
      <defs>
        <clipPath id="clip0_33_151">
          <rect width="150" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function RoundPlusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="256px"
      height="256px"
      viewBox="0 0 256 256"
      id="Flat"
    >
      <path d="M128,28A100,100,0,1,0,228,128,100.113,100.113,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.10447,92.10447,0,0,1,128,220Zm44-92a4.0002,4.0002,0,0,1-4,4H132v36a4,4,0,0,1-8,0V132H88a4,4,0,0,1,0-8h36V88a4,4,0,0,1,8,0v36h36A4.0002,4.0002,0,0,1,172,128Z" />
    </svg>
  );
}

export function CrossSquared() {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="44" height="44" rx="14" fill="#F4F9FD" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.041 14.2423C29.601 13.8258 28.9125 13.8251 28.4716 14.2406L22.5 19.8679L16.5285 14.2406C16.0876 13.8251 15.3991 13.8258 14.9591 14.2423L14.8936 14.3042C14.4166 14.7557 14.4174 15.5155 14.8954 15.966L20.768 21.5L14.8954 27.034C14.4174 27.4845 14.4166 28.2443 14.8936 28.6958L14.9591 28.7577C15.3991 29.1742 16.0876 29.1749 16.5285 28.7594L22.5 23.1321L28.4716 28.7594C28.9125 29.1749 29.601 29.1742 30.041 28.7577L30.1064 28.6958C30.5835 28.2443 30.5826 27.4845 30.1046 27.034L24.232 21.5L30.1046 15.966C30.5826 15.5155 30.5835 14.7557 30.1064 14.3042L30.041 14.2423Z"
        fill="#0A1629"
      />
    </svg>
  );
}

export function DashboardIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
    >
      <path
        d="M6.25 9.2015H0.416667C0.166667 9.2015 0 9.36816 0 9.61816V15.4515C0 15.7015 0.166667 15.8682 0.416667 15.8682H6.25C6.5 15.8682 6.66667 15.7015 6.66667 15.4515V9.61816C6.66667 9.36816 6.5 9.2015 6.25 9.2015ZM5.83333 15.0348H0.833333V10.0348H5.83333V15.0348ZM6.25 0.868164H0.416667C0.166667 0.868164 0 1.03483 0 1.28483V7.11816C0 7.36816 0.166667 7.53483 0.416667 7.53483H6.25C6.5 7.53483 6.66667 7.36816 6.66667 7.11816V1.28483C6.66667 1.03483 6.5 0.868164 6.25 0.868164ZM5.83333 6.7015H0.833333V1.7015H5.83333V6.7015ZM14.5833 0.868164H8.75C8.5 0.868164 8.33333 1.03483 8.33333 1.28483V7.11816C8.33333 7.36816 8.5 7.53483 8.75 7.53483H14.5833C14.8333 7.53483 15 7.36816 15 7.11816V1.28483C15 1.03483 14.8333 0.868164 14.5833 0.868164ZM14.1667 6.7015H9.16667V1.7015H14.1667V6.7015ZM14.5833 12.1182H12.0833V9.61816C12.0833 9.36816 11.9167 9.2015 11.6667 9.2015C11.4167 9.2015 11.25 9.36816 11.25 9.61816V12.1182H8.75C8.5 12.1182 8.33333 12.2848 8.33333 12.5348C8.33333 12.7848 8.5 12.9515 8.75 12.9515H11.25V15.4515C11.25 15.7015 11.4167 15.8682 11.6667 15.8682C11.9167 15.8682 12.0833 15.7015 12.0833 15.4515V12.9515H14.5833C14.8333 12.9515 15 12.7848 15 12.5348C15 12.2848 14.8333 12.1182 14.5833 12.1182Z"
        fill="white"
      />
    </svg>
  );
}

export function DashboardIconFilled() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        d="M5.83333 8.33333H0.833333C0.333333 8.33333 0 8.66667 0 9.16667V14.1667C0 14.6667 0.333333 15 0.833333 15H5.83333C6.33333 15 6.66667 14.6667 6.66667 14.1667V9.16667C6.66667 8.66667 6.33333 8.33333 5.83333 8.33333ZM5.83333 0H0.833333C0.333333 0 0 0.333333 0 0.833333V5.83333C0 6.33333 0.333333 6.66667 0.833333 6.66667H5.83333C6.33333 6.66667 6.66667 6.33333 6.66667 5.83333V0.833333C6.66667 0.333333 6.33333 0 5.83333 0ZM14.1667 10.8333H12.5V9.16667C12.5 8.66667 12.1667 8.33333 11.6667 8.33333C11.1667 8.33333 10.8333 8.66667 10.8333 9.16667V10.8333H9.16667C8.66667 10.8333 8.33333 11.1667 8.33333 11.6667C8.33333 12.1667 8.66667 12.5 9.16667 12.5H10.8333V14.1667C10.8333 14.6667 11.1667 15 11.6667 15C12.1667 15 12.5 14.6667 12.5 14.1667V12.5H14.1667C14.6667 12.5 15 12.1667 15 11.6667C15 11.1667 14.6667 10.8333 14.1667 10.8333ZM14.1667 0H9.16667C8.66667 0 8.33333 0.333333 8.33333 0.833333V5.83333C8.33333 6.33333 8.66667 6.66667 9.16667 6.66667H14.1667C14.6667 6.66667 15 6.33333 15 5.83333V0.833333C15 0.333333 14.6667 0 14.1667 0Z"
        fill="white"
      />
    </svg>
  );
}

// Inner SidebarIcon
export const BullhornLightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
    >
      <g clipPath="url(#clip0_1393_72088)">
        <path
          d="M12.5541 1.05803C13.4074 0.186416 14.875 0.770791 14.875 1.97145V14.9728C14.875 16.1714 13.4074 16.7558 12.5541 15.8859L11.7904 15.0492C10.3527 13.5318 8.43691 12.5656 6.375 12.3033V15.6435C6.375 16.6695 5.5416 17.5029 4.51562 17.5029H3.98438C2.9574 17.5029 2.125 16.6695 2.125 15.6435V12.1904C0.95127 12.1904 0 11.2374 0 10.0355V6.84799C0 5.70581 0.95127 4.72299 2.125 4.72299H4.76797L5.7375 4.69975C8.03848 4.57026 10.2066 3.56686 11.7904 1.89276L12.5541 1.05803ZM13.8125 1.97145C13.8125 1.70151 13.5203 1.61452 13.3543 1.78883L12.5641 2.62356C11.1729 4.08881 9.38652 5.09819 7.4375 5.53315V11.4101C9.38652 11.8451 11.1729 12.8246 12.5641 14.3187L13.3543 15.1554C13.5203 15.3281 13.8125 15.2119 13.8125 14.9728V1.97145ZM6.375 11.2308V5.71245C6.18242 5.73237 5.98984 5.74897 5.79395 5.75893L4.79453 5.78549H2.125C1.5383 5.78549 1.0625 6.29018 1.0625 6.84799V10.0355C1.0625 10.6531 1.5383 11.098 2.125 11.098H4.79453L5.79395 11.1843C5.98984 11.1644 6.18242 11.2109 6.375 11.2308ZM3.1875 12.1904V15.6435C3.1875 16.0851 3.54277 16.4404 3.98438 16.4404H4.51562C4.95723 16.4404 5.3125 16.0851 5.3125 15.6435V12.2203L4.76797 12.1904H3.1875ZM16.4688 6.84799C16.7609 6.84799 17 7.11694 17 7.37924V9.50424C17 9.82631 16.7609 10.0355 16.4688 10.0355C16.1766 10.0355 15.9375 9.82631 15.9375 9.50424V7.37924C15.9375 7.11694 16.1766 6.84799 16.4688 6.84799Z"
          fill="#565656"
        />
      </g>
      <defs>
        <clipPath id="clip0_1393_72088">
          <rect
            width="17"
            height="17"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BullHornSolidIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
    >
      <g clipPath="url(#clip0_1391_71243)">
        <path
          d="M15.9375 1.56435C15.9375 1.13603 15.6785 0.747552 15.2801 0.581536C14.8816 0.41552 14.4268 0.508489 14.1213 0.810637L12.6736 2.26161C11.0799 3.85536 8.91836 4.75185 6.66387 4.75185H6.375H5.3125H2.125C0.95293 4.75185 0 5.70478 0 6.87685V10.0643C0 11.2364 0.95293 12.1893 2.125 12.1893V16.4393C2.125 17.027 2.5998 17.5018 3.1875 17.5018H5.3125C5.9002 17.5018 6.375 17.027 6.375 16.4393V12.1893H6.66387C8.91836 12.1893 11.0799 13.0858 12.6736 14.6796L14.1213 16.1272C14.4268 16.4327 14.8816 16.5224 15.2801 16.3563C15.6785 16.1903 15.9375 15.8052 15.9375 15.3735V10.4761C16.5551 10.1839 17 9.39697 17 8.4706C17 7.54423 16.5551 6.75732 15.9375 6.46513V1.56435ZM13.8125 4.11103V8.4706V12.8302C11.8602 11.0538 9.31348 10.0643 6.66387 10.0643H6.375V6.87685H6.66387C9.31348 6.87685 11.8602 5.8874 13.8125 4.11103Z"
          fill="#7B68EE"
        />
      </g>
      <defs>
        <clipPath id="clip0_1391_71243">
          <rect
            width="17"
            height="17"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MembersIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="14"
      viewBox="0 0 17 14"
      fill="none"
    >
      <g clipPath="url(#clip0_1637_64076)">
        <path
          d="M7.29672 8.27812H4.60328C2.06045 8.27812 0 10.3394 0 12.8814C0 13.3914 0.41225 13.8031 0.920656 13.8031H10.9783C11.4883 13.8031 11.9 13.3914 11.9 12.8814C11.9 10.3394 9.83875 8.27812 7.29672 8.27812ZM10.9783 12.9531H0.920656C0.881875 12.9531 0.85 12.9213 0.85 12.8814C0.85 10.8122 2.53406 9.12813 4.60328 9.12813H7.29672C9.36594 9.12813 11.05 10.8122 11.05 12.8814C11.05 12.9213 11.0181 12.9531 10.9783 12.9531ZM5.95 7.00313C7.82797 7.00313 9.35 5.48083 9.35 3.60313C9.35 1.72542 7.82797 0.203125 5.95 0.203125C4.07203 0.203125 2.55 1.72542 2.55 3.60313C2.55 5.48083 4.07203 7.00313 5.95 7.00313ZM5.95 1.05313C7.35622 1.05313 8.5 2.19691 8.5 3.60313C8.5 5.00908 7.35622 6.15313 5.95 6.15313C4.54378 6.15313 3.4 5.00828 3.4 3.60313C3.4 2.19691 4.54484 1.05313 5.95 1.05313ZM9.96359 6.60469C10.4364 6.865 10.9517 7.00313 11.475 7.00313C13.1166 7.00313 14.45 5.66969 14.45 4.02813C14.45 2.38656 13.1166 1.05313 11.475 1.05313C11.1342 1.05313 10.8006 1.11039 10.4832 1.22289C10.2619 1.30132 10.1461 1.54403 10.2246 1.76529C10.303 1.98693 10.5465 2.10157 10.767 2.02385C10.9942 1.94377 11.2306 1.90313 11.475 1.90313C12.6464 1.90313 13.6 2.85645 13.6 4.02813C13.6 5.1998 12.6464 6.15313 11.475 6.15313C11.101 6.15313 10.7336 6.05476 10.413 5.86917C10.2097 5.75089 9.94978 5.82062 9.83238 6.02398C9.71391 6.2275 9.78297 6.48781 9.96359 6.60469ZM13.0342 8.70312H11.9C11.6651 8.70312 11.475 8.89321 11.475 9.12813C11.475 9.36304 11.6663 9.55313 11.9 9.55313H13.0334C14.7528 9.55313 16.15 10.9503 16.15 12.6689C16.15 12.8256 16.0225 12.9531 15.8658 12.9531H13.175C12.9401 12.9531 12.75 13.1432 12.75 13.3781C12.75 13.613 12.9401 13.8031 13.175 13.8031H15.8658C16.4927 13.8031 17 13.2958 17 12.6689C17 10.4589 15.2203 8.70312 13.0342 8.70312Z"
          fill="#565656"
        />
      </g>
      <defs>
        <clipPath id="clip0_1637_64076">
          <rect
            width="17"
            height="13.6"
            fill="white"
            transform="translate(0 0.203125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MembersIconFilled = () => {
  return (
    <svg
      width="17"
      height="14"
      viewBox="0 0 17 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.0398438 12.3873C0.199219 11.1788 0.815469 10.1136 1.70797 9.36984C2.53141 8.68719 3.58594 8.27812 4.73609 8.27812H5.95H7.16391C8.31406 8.27812 9.36859 8.68719 10.1894 9.36984C11.0819 10.1136 11.6981 11.1788 11.8575 12.3873C11.8841 12.5919 11.8973 12.8017 11.8973 13.0142C11.8973 13.4498 11.5441 13.8031 11.1084 13.8031H10.5905H1.30953H0.788906C0.353281 13.8031 0 13.4498 0 13.0142C0 12.8017 0.0132813 12.5919 0.0398438 12.3873ZM2.55 3.60313C2.55 2.70139 2.90821 1.83659 3.54584 1.19896C4.18346 0.561338 5.04826 0.203125 5.95 0.203125C6.85174 0.203125 7.71654 0.561338 8.35416 1.19896C8.99179 1.83659 9.35 2.70139 9.35 3.60313C9.35 4.50486 8.99179 5.36966 8.35416 6.00729C7.71654 6.64491 6.85174 7.00313 5.95 7.00313C5.04826 7.00313 4.18346 6.64491 3.54584 6.00729C2.90821 5.36966 2.55 4.50486 2.55 3.60313ZM8.075 3.60313C8.075 3.03954 7.85112 2.49904 7.4526 2.10052C7.05409 1.70201 6.51359 1.47813 5.95 1.47813C5.38642 1.47813 4.84591 1.70201 4.4474 2.10052C4.04888 2.49904 3.825 3.03954 3.825 3.60313C3.825 4.16671 4.04888 4.70721 4.4474 5.10573C4.84591 5.50424 5.38642 5.72813 5.95 5.72813C6.51359 5.72813 7.05409 5.50424 7.4526 5.10573C7.85112 4.70721 8.075 4.16671 8.075 3.60313ZM4.73609 9.55313C3.46641 9.55313 2.35875 10.2358 1.75578 11.2531C1.52734 11.6356 1.37328 12.0686 1.30953 12.5281H2.60313H9.29688H10.5931C10.5825 12.4564 10.5719 12.3873 10.5559 12.3156C10.4789 11.9358 10.3381 11.5772 10.1442 11.2531C9.54125 10.2358 8.43359 9.55313 7.16391 9.55313H4.73609ZM16.1845 13.8031H12.5481C12.6783 13.5694 12.75 13.3011 12.75 13.0142C12.75 11.2877 11.9664 9.74172 10.7339 8.71641C10.8481 8.70578 10.965 8.70312 11.0845 8.70312H12.7155C15.0822 8.70312 17 10.6209 17 12.9877C17 13.4392 16.6334 13.8031 16.1845 13.8031ZM11.475 7.00313C10.6516 7.00313 9.90781 6.66844 9.36859 6.12922C9.89188 5.42266 10.2 4.54875 10.2 3.60313C10.2 2.89125 10.0247 2.21922 9.71391 1.62953C10.208 1.26828 10.8162 1.05313 11.475 1.05313C13.1192 1.05313 14.45 2.38391 14.45 4.02813C14.45 5.67234 13.1192 7.00313 11.475 7.00313Z"
        fill="#7B68EE"
      />
    </svg>
  );
};
